import { createFileRoute } from '@tanstack/react-router';
import { dashboardRouteOptions } from '../-workspaceRouteOptions';

export const Route = createFileRoute('/_authed/$orgSlug/dashboard')({
  ...dashboardRouteOptions,
});
